<template>
  <div class="grid_output_label">
    <template v-if="outsideLabel">
      <span>{{ label || t(`entities.${type}.fields.${field}`) }}</span>
    </template>
    <v-tooltip :text="dataBaseValue">
      <template v-slot:activator="activator">
        <v-text-field
          :key="props.id"
          :id="props.field"
          :data-cy="props.id?.split('_')[1] + '-' + props.field"
          v-bind="activator.props"
          ref="outputField"
          :class="{ 'output_area': !outsideLabel || !unit }"
          :model-value="value"
          :label="
            hideLabel || outsideLabel
              ? ''
              : label || t(`entities.${type}.fields.${field}`)
          "
          readonly
          variant="filled"
          role="CalcOutput"
          :base-color="baseColor"
          :bg-color="baseColor">
        </v-text-field>
      </template>
    </v-tooltip>

    <template v-if="unit">
      <span>{{ unit }}</span>
    </template>
  </div>
  <!-- <v-btn @click="copyName">,"{{ props.field }}"</v-btn> -->
</template>

<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { computed } from "vue";
import { useSpaceStore } from "../../stores/spaceStore";
import { useCalculationStore } from "../../stores/calculationStore";

const spaceStore = useSpaceStore();
const calculationStore = useCalculationStore();

const { t } = useTranslation();

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  field: {
    type: String,
    required: true
  },
  hideLabel: {
    type: Boolean,
    default: false
  },
  label: {
    type: String,
    default: null
  },
  unit: {
    type: String,
    default: null
  },
  outsideLabel: {
    type: Boolean,
    default: false
  }
});

const type = props.id?.split("_")[1];

const baseColor = computed(() => {
  if (
    !calculationStore.freezeCalculation &&
    !calculationStore.stepByStepCalculation
  ) {
    return "";
  }

  // is getting calculated
  if (
    calculationStore.focusCalculation.normalElements[props.id]?.includes(
      props.field
    ) ||
    calculationStore.focusCalculation.extraElements[props.id]?.includes(
      props.field
    ) ||
    calculationStore.focusCalculation.outputQuantityQueue.filter((element) => {
      const [element_id, field] = element.split("|");
      return element_id === props.id && props.field === field;
    }).length
  ) {
    return "green";
  }

  if (
    calculationStore.currentCalculation &&
    calculationStore.currentCalculation.elements[props.id]?.includes(
      props.field
    )
  ) {
    return "orange";
  }
});

const dataBaseValue = computed(() => {
  return spaceStore.calculationElements?.[props.id]?.[props.field] || 0;
});

const value = computed(() => {
  return Math.round((parseFloat(dataBaseValue.value) || 0) * 100) / 100;
});
</script>

<style lang="scss" scoped>
.outputField {
  //   opacity: 1;
  pointer-events: hover;
}

.grid_output_label {
  font-size: 85%;
  display: grid;
  row-gap: 10px;
  column-gap: 20px;
  grid-template-columns: [start] 2fr 3fr 2fr [end];
  grid-area: "name output unit";
  align-items: center;

  .output_area {
    grid-column-start: start;
    grid-column-end: end;
  }
}
</style>
